<template>
    <carousel :perPage="1" :navigationClickTargetSize="14" :loop="true"
              :autoplay="true" :autoplayTimeout="7000" :navigationEnabled="false" :paginationEnabled="false">
        <slide v-for="testimonial in data" :key="testimonial.name" class="col-xs-12">
            <div class="slide">
                <div class="col-xs-12 no-padding">
                    <div class="person-image col-xs-12 col-md-2">
                        <img v-if="testimonial.rounded" :src="testimonial.image.url" :alt="testimonial.image.alt" class="img img-responsive img-circle">
                        <img v-else :src="testimonial.image.url" :alt="testimonial.image.alt" class="img img-responsive">
                    </div>

                    <div class="visible-xs col-xs-12">
                        <i class="icon col-xs-12" v-bind:style="{color: iconColor}"></i>
                    </div>

                    <div class="quote-wrapper col-xs-12 col-md-10 bottom-buffer">
                        <i class="icon hidden-xs"></i>
                        <div class="quote bottom-buffer">
                            <div class="testimonial-text col-xs-12 no-padding" v-html="testimonial.text"></div>
                            <div class="person col-xs-12 no-padding">
                                {{ testimonial.caption }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </slide>
    </carousel>
</template>

<script>
import VueCarousel from "vue-carousel";
    export default {
        props: ['data', 'iconColor'],
        name: "partner-testimonials",
        components: {
            'carousel': VueCarousel.Carousel,
            'slide': VueCarousel.Slide
        },
    }
</script>

<style scoped>
    .slide {
        width: 100%;
    }

    .slide p {
        height: initial;
    }

    .quote-wrapper {
        display: flex;
    }

    .quote .glyphicon {
        width: 10px;
        top: 2px;
    }

    .quote .glyphicon:first-child {
        margin-left: -2px;
    }

    .quote .glyphicon:nth-child(2) {
        margin-left: -8px;
        margin-right: 10px;
    }

    .icon {
        font-size: 100px;
        font-family: 'Times New Roman', sans-serif;
        font-weight: 600;
        min-width: 60px;
        color: #B3E5E1;
    }

    .icon::before {
        content: '\2018\2018';
        letter-spacing: -5px;
        position: absolute;
        top: -53px;
        left: -5px;
    }

    .person-image {
        max-width: 150px;
    }

    .VueCarousel-slide {
        padding: 0;
    }

    @media all and (max-width: 767px) {

        .quote {
            padding-left: 25px;
        }

        .icon::before {
            top: -13px;
            left: -15px;
        }

        .person {
            font-size: 15px;
        }
    }

    @media all and (max-width: 991px) {
        .quote {
            font-size: 18px;
            line-height: initial;
        }

        .person-image {
            margin: 0 auto 35px;
            float: none;
        }
    }
</style>
